




















































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import store from "@/store";

import getUrlParam from "@/common/utils/getUrlParam";
@Component
export default class GachaRadio extends Vue {
  @Getter("xcxFlag") xcxFlag!: boolean;
  type: string = getUrlParam("type") as string;

  get disabled() {
    return getUrlParam("type") === "reEdit";
  }

  get sectionConf() {
    return store.getters.section;
  }

  get distributeTypeParameter() {
    return store.getters.distributeTypeParameter;
  }

  toggleDistributeMode(type: string) {
    if (getUrlParam("type") === "reEdit" && getUrlParam("broadcastId")) {
      return;
    }
    if(type === 'AFTER_BUY'){
      store.dispatch("changeDistributeParameter", { distributeMode: 'ANY_TIME' });
    } else {
      store.dispatch("changeDistributeParameter", { distributeMode: 'AFTER_BUY' });
    }
  }
}
